<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="3" lg="2" class="pb-0">
      <FilterSearch :fetchData="fetchCategories" />
    </v-col>
    <v-col cols="12" sm="12" md="3" lg="2">
      <FilterDates :fetchData="fetchCategories" dateRange />
    </v-col>
  </v-row>
</template>

<script>
import FilterSearch from '@/components/filters/FilterSearch'
import FilterDates from '@/components/filters/FilterDates'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CategoryListFilters',

  components: {
    FilterDates,
    FilterSearch,
  },

  computed: {
    ...mapGetters(['isLoading']),
  },

  methods: {
    ...mapActions(['fetchCategories']),
  },
}
</script>
